import{
    apiRequest,
    employeeStatusDetail,
    employeeStatusUpdate,
} from "../../../../../services/adapters/master/employeeStatusService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", employeeStatusDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", employeeStatusUpdate, {
            body: query
        }, true)
    }

}

export default UpdateRepository